var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleChromeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18825_7507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 6.00002H22.3913C21.3384 4.17571 19.8238 2.66077 17.9996 1.60752C16.1755 0.554277 14.1063 -0.000146935 11.9999 2.92099e-08C9.89358 0.000146993 7.82439 0.554859 6.00043 1.60836C4.17647 2.66186 2.66202 4.17701 1.60938 6.00147L6.80467 15L6.80932 14.9988C6.28082 14.0874 6.00192 13.0529 6.00074 11.9993C5.99956 10.9458 6.27613 9.91062 6.80258 8.99807C7.32903 8.08552 8.08675 7.32788 8.99935 6.80153C9.91196 6.27518 10.9472 5.99872 12.0007 6.00002Z",
    fill: "url(#paint0_linear_18825_7507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7498C14.6233 16.7498 16.75 14.6231 16.75 11.9998C16.75 9.3764 14.6233 7.24976 12 7.24976C9.37665 7.24976 7.25 9.3764 7.25 11.9998C7.25 14.6231 9.37665 16.7498 12 16.7498Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1955 15.0016L12.0002 24.0001C14.1065 24.0004 16.1758 23.4462 18 22.393C19.8242 21.3399 21.3389 19.8251 22.392 18.0009C23.445 16.1767 23.9992 14.1074 23.9988 12.001C23.9985 9.89467 23.4435 7.82555 22.3898 6.00171H11.9993L11.998 6.00636C13.0516 6.00433 14.087 6.28007 15 6.8058C15.9129 7.33153 16.6712 8.08865 17.1982 9.00085C17.7253 9.91305 18.0026 10.9481 18.0021 12.0016C18.0016 13.0551 17.7234 14.0899 17.1955 15.0016Z",
    fill: "url(#paint1_linear_18825_7507)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80541 15.0015L1.61011 6.00293C0.556674 7.82693 0.00203163 9.89613 0.00195313 12.0025C0.00187464 14.1088 0.556363 16.1781 1.60966 18.0021C2.66297 19.8262 4.17795 21.3408 6.00229 22.3937C7.82663 23.4465 9.89601 24.0005 12.0024 23.9999L17.1977 15.0014L17.1943 14.998C16.6693 15.9114 15.9128 16.6702 15.001 17.198C14.0892 17.7257 13.0544 18.0038 12.0009 18.0042C10.9474 18.0045 9.91236 17.7272 9.00022 17.2C8.08808 16.6728 7.33104 15.9145 6.80541 15.0015Z",
    fill: "url(#paint2_linear_18825_7507)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18825_7507",
    x1: 1.60937,
    y1: 7.50002,
    x2: 22.3913,
    y2: 7.50002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18825_7507",
    x1: 10.3608,
    y1: 23.8397,
    x2: 20.7518,
    y2: 5.84201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18825_7507",
    x1: 13.3002,
    y1: 23.2507,
    x2: 2.90916,
    y2: 5.25293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18825_7507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeIcon);
export default __webpack_public_path__ + "static/media/GoogleChromeIcon.10ec6089ce15522ca5cdabf4c9bfc0d5.svg";
export { ForwardRef as ReactComponent };